 
import { Box, Button, Flex, Img, Spacer, Stack, Text, color } from "@chakra-ui/react";
import { cfg } from "../../dados/dados"; 
export const Bt1 = (props)=>{
    const {size={base:'sm',md:'md',md:'lg'},className={},bg1='',bg2='',leftIcon='',children, ...rest}=props;  
    return <Button type="submit" w='fit-content' size={size} className={className} leftIcon={leftIcon} textShadow={'lg'} background={'linear-gradient(90deg, '+bg1+' 0%, '+bg1+' 35%, '+bg2+' 50%, '+bg2+' 100%)'} color={cfg.theme.bt1.clr} backgroundSize=" 200% 100%" backgroundPosition={'top left'} fontFamily={cfg.theme.padrao.font}  fontWeight={'bold'} _hover={{color:'tema.cor001', backgroundPosition:'top right'}} transition={'1s'} {...rest}>
        <Text pt={'3px'}>{children}</Text>
    </Button>
}  